(() => {
  const compactExcerpt = (excerpt) => {
    const walker = document.createTreeWalker(excerpt, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    const totalWords = nodes.reduce((count, node) => count + [...node.textContent.matchAll(/\S+/g)].length, 0);
    if (totalWords <= 18) return;
    let wordsLeft = 18;
    for (const node of nodes) {
      const words = [...node.textContent.matchAll(/\S+/g)];
      if (words.length < wordsLeft) {
        wordsLeft -= words.length;
        continue;
      }
      const lastWord = words[wordsLeft - 1];
      const offset = lastWord.index + lastWord[0].length;
      const tail = document.createRange();
      tail.setStart(node, offset);
      tail.setEnd(excerpt, excerpt.childNodes.length);
      tail.deleteContents();
      node.textContent += '…';
      return;
    }
  };
  const initialize = (root) => {
    root.querySelectorAll('[data-native-article-carousel]').forEach((section) => {
      if (section.dataset.nativeArticleReady) return;
      const track = section.querySelector('[data-native-article-track]');
      const controls = section.querySelector('[data-native-article-controls]');
      const previous = section.querySelector('[data-native-article-previous]');
      const next = section.querySelector('[data-native-article-next]');
      const dots = section.querySelector('[data-native-article-dots]');
      const status = section.querySelector('[data-native-article-status]');
      if (!track || !controls || !previous || !next || !dots || !status) return;
      section.dataset.nativeArticleReady = 'true';
      section.querySelectorAll('[data-native-article-excerpt]').forEach(compactExcerpt);
      const desktop = window.matchMedia('(min-width: 1200px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let positions = [];
      let pending = false;
      const scrollTo = (left) => track.scrollTo({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      const update = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const enabled = desktop.matches && maximum > 2;
        controls.hidden = !enabled;
        previous.disabled = !enabled || track.scrollLeft <= 2;
        next.disabled = !enabled || track.scrollLeft >= maximum - 2;
        let selected = 0;
        positions.forEach((left, index) => {
          if (Math.abs(track.scrollLeft - left) < Math.abs(track.scrollLeft - positions[selected])) selected = index;
        });
        dots.querySelectorAll('button').forEach((button, index) => button.setAttribute('aria-current', index === selected ? 'true' : 'false'));
        status.textContent = positions.length ? `Article slider page ${selected + 1} of ${positions.length}` : '';
      };
      const buildPositions = () => {
        const items = [...track.children];
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        positions = [0];
        if (desktop.matches && maximum > 2) {
          for (let index = 2; index < items.length; index += 2) {
            const left = Math.min(maximum, items[index].offsetLeft - items[0].offsetLeft);
            if (left > positions[positions.length - 1] + 2) positions.push(left);
          }
          if (maximum > positions[positions.length - 1] + 2) positions.push(maximum);
        }
        dots.replaceChildren();
        positions.forEach((left, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `Go to article slider page ${index + 1}`);
          button.setAttribute('aria-controls', track.id);
          button.addEventListener('click', () => scrollTo(left));
          dots.append(button);
        });
        update();
      };
      const move = (direction) => {
        if (!desktop.matches) return;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const first = track.children[0];
        const third = track.children[2];
        const step = first && third ? third.offsetLeft - first.offsetLeft : track.clientWidth;
        scrollTo(Math.max(0, Math.min(maximum, track.scrollLeft + direction * step)));
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || !desktop.matches) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          scrollTo(event.key === 'Home' ? 0 : track.scrollWidth - track.clientWidth);
        }
      });
      track.addEventListener('scroll', () => {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(() => { pending = false; update(); });
      }, { passive: true });
      if (typeof ResizeObserver === 'function') {
        const observer = new ResizeObserver(buildPositions);
        observer.observe(track);
      } else {
        window.addEventListener('resize', buildPositions);
      }
      desktop.addEventListener('change', buildPositions);
      buildPositions();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
